import { extendAlmaGlobal } from "../../utils";
function almaSessionCount() {
    try {
        ((window) => {
            const week = 1000 * 60 * 60 * 24 * 7;
            const thirtyminutes = 1000 * 60 * 30;
            function expired(current, expiry) {
                return current > expiry;
            }
            function updateLocalStorage(date, value) {
                const newValue = {
                    timestamp: date,
                    count: value,
                };
                localStorage.setItem("alma-sc", JSON.stringify(newValue));
            }
            function getWeekStart(d) {
                const day = d.getDay();
                d.setDate(d.getDate() - day + (day === 0 ? -6 : 1));
                d.setHours(0, 0, 0, 0);
                return d;
            }
            function lsHasExpired() {
                const lsAlmaSc = localStorage.getItem("alma-sc");
                if (!lsAlmaSc) {
                    return true;
                    // Key available in local storage
                }
                const obj = JSON.parse(lsAlmaSc);
                // Timestamp not found
                if (!Object.prototype.hasOwnProperty.call(obj, "timestamp"))
                    return false;
                // Compare timestamp to expiry value
                return expired(new Date().getTime() - Date.parse(obj.timestamp), week);
            }
            function handleLocalStorage() {
                // Update date
                if (lsHasExpired()) {
                    updateLocalStorage(getWeekStart(new Date()).toDateString(), 1);
                    // Update count
                }
                else {
                    const lsValue = localStorage.getItem("alma-sc");
                    if (lsValue) {
                        try {
                            const lsoObj = JSON.parse(lsValue);
                            if (lsValue) {
                                updateLocalStorage(lsoObj.timestamp, lsoObj.count + 1);
                            }
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                }
            }
            function needToUpdateCount() {
                const stAlmaSc = sessionStorage.getItem("alma-sc");
                // Key not found from session storage
                if (!stAlmaSc) {
                    return true;
                    // Key available in session storage
                }
                const obj = JSON.parse(stAlmaSc);
                // Timestamp not found
                if (!Object.prototype.hasOwnProperty.call(obj, "timestamp"))
                    return false;
                // Compare timestamp to expiry value
                return expired(new Date().getTime() - obj.timestamp, thirtyminutes);
            }
            function updateCount() {
                // Session storage is empty, increment local storage value
                if (needToUpdateCount()) {
                    // Store current timestamp to session storage
                    const obj = {
                        timestamp: new Date().getTime(),
                    };
                    sessionStorage.setItem("alma-sc", JSON.stringify(obj));
                    handleLocalStorage();
                }
            }
            function sessionCount() {
                // Update session / local storaget prior to return the value
                updateCount();
                // Return value from local storage
                const lsAlmaSc = localStorage.getItem("alma-sc");
                if (lsAlmaSc) {
                    const obj = JSON.parse(lsAlmaSc);
                    return obj.count;
                }
                return undefined;
            }
            // Set to global
            extendAlmaGlobal({ ...window?.ALMA?.dmp ?? {}, sc: sessionCount }, "dmp");
        })(window);
    }
    catch (e) {
        console.error("DMP session failed", e);
    }
}
export default almaSessionCount;
//# sourceMappingURL=session-count.js.map